// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__u9ksE","col":"styles_col__1X7CI"};